<template>
  <div>
    <span v-if="object.fiscal_passed">{{ $t('yes') }}</span>
    <span v-else class="text-secondary">{{ $t('no') }}</span>
    <span v-if="object.fiscal_url" class="ml-2">
      <a :href="object.fiscal_url" target="_blank">
        <LinkSvg class="svg-size-md svg-light"/>
      </a>
    </span>
  </div>
</template>

<script setup>
import LinkSvg from "@/assets/svg-vue/general/link.svg.vue"

defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  },
})
</script>
